// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"277becb9","976":"4e2c5247"}[chunkId] + ".chunk.js";
};